<template>
  <div class="message">
    <p class="black-title">
      消息
    </p>
    <!--    <router-link-->
    <!--      class="msg-item"-->
    <!--      tag="div"-->
    <!--      :to="{ path: '/notice', query: { type: 0 } }"-->
    <!--    >-->
    <!--      <img src="../../../../static/img/undo.png" />-->
    <!--      <div class="item-text">-->
    <!--        <span>待处理消息</span>-->
    <!--        <p>{{ this.pendList }}<label v-if="this.schoolCode=='14246' && this.pendList!=='暂无'">新消息</label></p>-->
    <!--      </div>-->
    <!--    </router-link>-->
    <template v-if="schoolCode != '12763'&&schoolCode!='13720'">
      <router-link
        class="msg-item"
        tag="div"
        :to="{ path: '/notice', query: { type: 1 } }"
      >
        <span class="imgspan"
          ><img src="../../../../static/img/unread.png"
        /></span>
        <div class="dot" v-if="wdtznb > 0">
          <span class="red-dot">{{ wdtznb }}</span>
        </div>

        <div class="item-text item-text-dot" v-if="wdtznb > 0">
          <span>未读消息</span>
          <p>{{ this.unreadList == "undefined" ? "暂无" : this.unreadList }}</p>
        </div>
        <div class="item-text" v-else>
          <span>未读消息</span>
          <div class="dot">
            <span v-if="wdxx > 0 && schoolCode == '14621'" class="red-dot">{{
              wdxx
            }}</span>
          </div>

          <p>暂无</p>
        </div>
      </router-link>
      <router-link
        class="msg-item"
        tag="div"
        :to="{ path: '/notice', query: { type: 2 } }"
      >
        <img src="../../../../static/img/read.png" />
        <div class="item-text">
          <span>已读消息</span>
          <p>{{ this.readList == "undefined" ? "暂无" : this.readList }}</p>
        </div>
      </router-link>
    </template>
    <router-link v-else-if="schoolCode!='13720'" class="msg-item" tag="div" :to="{ path: '/notice' }">
      <img src="../../../../static/img/unread.png" />
      <div class="dot" v-if="shxx > 0">
        <span class="red-dot">{{ shxx }}</span>
      </div>
      <div class="item-text item-text-dot" v-if="shxx > 0">
        <span>审核消息</span>
      </div>
      <div class="item-text" v-else>
        <span>审核消息</span>
      </div>
    </router-link>
    <router-link class="msg-item" tag="div" :to="{ path: '/adv' }">
      <img src="../../../../static/img/unread.png" />
      <div class="dot" v-if="wdggnb > 0">
        <span class="red-dot">{{ wdggnb }}</span>
      </div>
      <div class="item-text item-text-dot" v-if="wdggnb > 0">
        <span>已收公告</span>
      </div>
      <div class="item-text" v-else>
        <span>已收公告</span>
      </div>
    </router-link>
    <router-link
      v-if="schoolCode == '10294'"
      class="msg-item"
      tag="div"
      :to="{ path: '/pass/unDeal' }"
    >
      <img src="../../../../static/img/dclxx.png" />
      <div class="dot" v-if="num > 0">
        <span class="red-dot">{{ num }}</span>
      </div>
      <div class="item-text item-text-dot" v-if="num > 0">
        <span>待处理信息提醒</span>
      </div>
      <div class="item-text" v-else>
        <span>待处理信息提醒</span>
      </div>
    </router-link>
    <router-link
      v-if="schoolCode == '10555' && userType != '2'"
      class="msg-item"
      tag="div"
      :to="{ path: '/notice', query: { type: 3 } }"
    >
      <img src="../../../../static/img/dshmsg.png" />
      <div class="item-text">
        <span>待审信息</span>
        <p>{{ this.dshList == "undefined" ? "暂无" : this.dshList }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      num: 0,
      pendList: "",
      unreadList: "",
      readList: "",
      dshList: "",
      userType: "",
      schoolCode: "",
      xjyj: "",
      wdtznb: 0,
      wdggnb: 0,
      shxx: 0
      // advList:''
    };
  },
  methods: {
    async getMsg() {
      const res = await Api.getMsgApi();
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].pendingMsg == undefined) {
          res.data[i].pendingMsg = "";
        }
        if (res.data[i].unReadMsg == undefined) {
          res.data[i].unReadMsg = "";
        }
        if (res.data[i].readMsg == undefined) {
          res.data[i].readMsg = "";
        }
        if (res.data[i].dshMsg == undefined) {
          res.data[i].dshMsg = "";
        }
        if (res.data[i].xjyj == undefined) {
          res.data[i].xjyj = "";
        }
        // if(res.data[i].advList == undefined){
        //   res.data[i].advList = ''
        // }
        this.pendList += res.data[i].pendingMsg + "";
        this.unreadList += res.data[i].unReadMsg + "";
        this.readList += res.data[i].readMsg + "";
        this.dshList += res.data[i].dshMsg + "";
        // this.advList += res.data[i].advList + ''
      }
      this.wdtznb = this.unreadList;
      this.wdggnb = res.gglyNbData;
      if (this.pendList == "") {
        this.pendList = "暂无";
      }
      if (this.unreadList == "") {
        this.unreadList = "暂无";
      }
      if (this.readList == "") {
        this.readList = "暂无";
      }
      if (this.dshList == "") {
        this.dshList = "暂无";
      }
      if (this.xjyj == "") {
        this.xjyj = 0;
      }
      // if(this.advList == ''){
      //   this.advList = '暂无'
      // }
      if (res.code == "1") {
        this.wdxx = res.data[0].unReadNum;
        this.shxx = res.data[0].msgNumAll;
        if (res.gglyNbData) {
          this.wdxx = this.wdxx * 1 + res.gglyNbData * 1;
        }
      }
    },
    // 判断用户类型更改设置
    userConfig() {
      let list = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userType = list.userType;
    },
    // 获取待处理list
    async getUnDeal() {
      const res = await Api.getNotShenHeMsg();
      if (res.data) {
        this.num = res.data.length;
      } else {
        this.num = 0;
      }
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getMsg();
    this.userConfig();
    if (this.schoolCode == "10294") {
      this.getUnDeal();
    }
  }
};
</script>

<style lang="less">
.message {
  padding: 0 20px;
  .black-title {
    margin: -22px 20px 10px 0;
  }
}
.msg-item {
  background-color: @attendance-background-color-10;
  border-radius: 5px;
  height: 82px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  color: @attendance-color-1;
  margin-bottom: 20px;
}
.msg-item img {
  width: 40px;
  height: 40px;
  margin-right: 16px;
}
.item-text {
  display: grid;
}
.item-text span {
  color: @attendance-color-1;
  font-weight: 600;
}
.item-text p {
  font-size: 14px;
  color: @attendance-color-2;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  height: 20px;
}
.item-text label {
  font-size: 14px;
  color: red;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  height: 20px;
  margin-left: 20px;
}
.item-text-dot {
  margin-left: 30px;
}
</style>

<style scoped lang="less">
.dot {
  position: relative;
  margin-top: -16px;
  margin-left: -30px;
  z-index: 2;
  .red-dot {
    position: absolute;
    background-color: red;
    color: #ffffff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    left: 100%;
    bottom: 50%;
  }
}

.imgspan {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/newMsg.vue